import type { Stripe } from '@stripe/stripe-js'
import { useEffect, useState } from 'react'

import type { RegionId } from '@snootsvet/shared'

import { stripeForRegion } from '@/customer/lib/stripe'

/** Resolves the Stripe.js instance for a region. */
export function useStripe(region: RegionId) {
  const [stripe, setStripe] = useState<Stripe | null>(null)

  useEffect(() => {
    const promise = stripeForRegion(region)
    if (promise) promise.then(setStripe).catch(() => {})
  }, [region])

  return stripe
}
